module.exports = __webpack_public_path__ + "static/media/ReviewIcon.f9bc5962.svg";